import { MultiSelectField } from "@dgs/core";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { ApplicationFilterType, ApplicationFilterTypeOption } from "../types/application";

interface Props {
	label: string;
	name: string;
	onlyEventTypes?: boolean;
}

const eventOptions: ApplicationFilterTypeOption[] = [
	{
		label: "DEEP",
		filterType: ApplicationFilterType.DEEP,
	},
	{
		label: "APP",
		filterType: ApplicationFilterType.APP,
	},
	{
		label: "DEEP & APP",
		filterType: ApplicationFilterType.DEEP_APP,
	},
	{
		label: "PARTICIPANT MANAGEMENT",
		filterType: ApplicationFilterType.PARTICIPANT_MANAGEMENT,
	},
	{
		label: "KRONOS",
		filterType: ApplicationFilterType.KRONOS,
	},
];

const options: ApplicationFilterTypeOption[] = [
	...eventOptions,
	{
		label: "Car fleet",
		filterType: ApplicationFilterType.CAR_FLEET,
	},
	{
		label: "MAILCOACH",
		filterType: ApplicationFilterType.MAILCOACH,
	},
];

export const ApplicationTypeFilterSelectField: FC<Props> = ({ label, name, onlyEventTypes = false }) => {
	const { t } = useTranslation();

	return (
		<MultiSelectField
			label={label}
			name={name}
			getLabel={(option) => t(option.label)}
			getValue={(option) => option.filterType}
			clearable={false}
			options={onlyEventTypes ? eventOptions : options}
		/>
	);
};
